@if (vm$ | async; as vm) {
  <div>
    <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
      <div class="vh">
        @if (error && derrors) {
          <info [option]="option">
            {{ error.message }}
          </info>
        }
        <ng-container formContent>
          <pr-search-input
            [formControl]="searchTerm"
            placeholder="Rechercher un produit"
            class="mbm"
          >
          </pr-search-input>
          <pr-form-select-list #formSelectList>
            @for (product of vm?.products?.content; track product) {
              <pr-form-select-list-option
                [labelIcon]="getIcon(product) ? getIcon(product) : undefined"
                [tooltipIcon]="
                  getTooltipIcon(product) ? getTooltipIcon(product) : undefined
                "
                [label]="product.name"
                (onSelect)="onProductSelect(product)"
                (onDeselect)="onProductDeselect(product)"
                [withMoreInfoAnchor]="false"
                [selected]="
                  _.map(form.get('products')?.value, 'productId').includes(
                    product.id
                  )
                "
              >
              </pr-form-select-list-option>
            }
          </pr-form-select-list>
          <mat-paginator
            [length]="vm.products?.totalElements"
            [pageSize]="pageSize"
            (page)="product.updatePagination($event.pageIndex)"
          >
          </mat-paginator>
        </ng-container>
      </div>
      <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
    </form>
  </div>
}
